import { render, staticRenderFns } from "./OfficialSignupWizard.vue?vue&type=template&id=6d18e2f1&scoped=true"
import script from "./OfficialSignupWizard.vue?vue&type=script&lang=js"
export * from "./OfficialSignupWizard.vue?vue&type=script&lang=js"
import style0 from "./OfficialSignupWizard.vue?vue&type=style&index=0&id=6d18e2f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18e2f1",
  null
  
)

export default component.exports